export default {"src":"/_next/static/media/bs-buddismo-e-societa-negativo.17125eb6.svg","height":23,"width":108,"blurWidth":0,"blurHeight":0};